/* eslint import/no-webpack-loader-syntax: off */

import React, { Fragment } from 'react';
import _ from 'lodash';
import pluralize from 'pluralize';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import Markdown from 'markdown-to-jsx/dist/index.js';

import Button from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';
import Divider from '@material-ui/core/Divider';
import Rating from '@material-ui/lab/Rating';

import { postCartData } from '../actions/carts';
import { updateLocalCart } from '../actions/local-cart';
import { fetchGroupData, fetchVariationData } from '../actions/items';
import { updateCustomerFavorites } from '../actions/users';

import { formatCurrency } from '../scripts/functions';
import { recordProductAdd } from '../scripts/tracking';

import priceMatch from '../storage/price-match.png';
import amazonLogo from '../storage/amazon-com-light.svg';
import deg360 from '../storage/360deg.png';

import ImageScrub from './ImageScrub';

import { ITEM_IMG_URL, DOWNLOADS_URL, AMAZON_BASE_URL } from '../config';

// import './styling/ItemPage.css';

const styles = () => ({
    fab: {
        position: 'absolute',
        right: -30,
        top: -10,
        zIndex: 5,
        height: 28,
        width: 10,
        minWidth: 10,
        padding: '0 14px',
        borderRadius: 20,
    },
});

export class ItemPage extends React.Component {
    state = {
        image: 0,
        variation: null,
        overrideImage: false,
        scrub: false,
        show: 'description',
        quantity: 1,
        relevantPricing: [],
        genericPricing: [],
        tierIndex: 0,
        tierPrice: 1,
        groups: 1,
        showScrub: false,
        showVideo: false,
        fade: false,
        pause: false,
        related: [],
        relatedSet: 0,
        relatedIndex: 0,
        maxRelated: Math.floor((window.innerWidth * 0.8425 - 75) / 148),
        variant: 'Variant 1',
        expandQuestions: false,
        expandReviews: false,
    };

    resize = () => {
        const { maxRelated } = this.state;

        const newWidth = window.innerWidth * 0.8425;
        const newMaxRelated = Math.floor((newWidth - 75) / 148);

        if (maxRelated !== newMaxRelated) {
            this.setState({ maxRelated: newMaxRelated });
        }
    };

    componentDidMount = () => {
        const { dispatch, item, cartQuantity } = this.props;
        const { groups: groupString, showOthers, variations } = item;

        if (cartQuantity) {
            this.setState({ quantity: cartQuantity });
        }

        this.transition = setInterval(() => this.incrementGroup(), 10000);

        this.handlePricing();

        if (groupString && showOthers) {
            dispatch(fetchGroupData(groupString));
        }

        if (variations && variations[0] && variations[0].id) {
            this.setState({ variation: variations[0] });
            dispatch(fetchVariationData(variations[0].id));
        }

        window.addEventListener('resize', this.resize);
    };

    componentWillUnmount = () => {
        clearInterval(this.transition);
        clearTimeout(this.fade);

        window.removeEventListener('resize', this.resize);
    };

    componentDidUpdate = (prevProps, prevState) => {
        const { related, item } = this.props;
        const { sku } = item;
        const { quantity } = this.state;

        if (prevState.quantity !== quantity) {
            this.handlePricing();
        }

        if (!prevProps.related && !_.isEmpty(related)) {
            const { categories, items } = related;

            const relatedCategories = categories.map((currentCategory) => {
                const { id, name: currentName, image } = currentCategory;

                return {
                    imageURL: image,
                    name: currentName,
                    link: `/products?show=${id}`,
                };
            });

            const relatedItems = items
                .filter(
                    (currentItem) =>
                        currentItem.showSelf && currentItem.sku !== sku
                )
                .map((currentItem) => {
                    const {
                        sku: currentSku,
                        name: currentName,
                        images,
                    } = currentItem;

                    const displayImage =
                        images.find((img) => img.thumbnail).imageFile ||
                        images[0].imageFile;

                    return {
                        imageURL: displayImage,
                        name: currentName,
                        link: `/item/${currentSku}`,
                        item: currentItem,
                    };
                });

            const relevantRelated = [...relatedCategories, ...relatedItems];

            this.setState({
                groups: Math.ceil(relevantRelated.length / 6),
                related: relevantRelated,
            });
        }
    };

    incrementGroup = () => {
        const { groups, showGroup, pause } = this.state;

        if (!pause) {
            if (groups > 1) {
                this.setState({ fade: true });

                this.fade = setTimeout(() => {
                    if (showGroup < groups - 1) {
                        this.setState({ showGroup: showGroup + 1 }, () =>
                            this.setState({ fade: false })
                        );
                    } else {
                        this.setState({ showGroup: 0 }, () =>
                            this.setState({ fade: false })
                        );
                    }
                }, 500);
            }
        }
    };

    addToCart = (relatedItem, newQuantity = 0) => {
        const { item, dispatch, loggedIn, itemCategories } = this.props;
        const { quantity } = this.state;
        const categoryString = (itemCategories || [])
            .map((category) => (category || {}).name)
            .join('/');

        recordProductAdd(
            { ...item, category: categoryString },
            newQuantity || quantity
        );
        if (loggedIn) {
            dispatch(
                postCartData(
                    relatedItem || { ...item, category: categoryString },
                    newQuantity || quantity
                )
            );
        } else {
            dispatch(
                updateLocalCart(
                    relatedItem || { ...item, category: categoryString },
                    newQuantity || quantity
                )
            );
        }
    };

    handleUpdateQuantity = (quantity) => {
        const { inCart } = this.props;

        this.setState({ quantity });

        if (quantity && inCart) {
            this.addToCart(null, quantity);
        }
    };

    handlePricing = () => {
        const { currentUser, item } = this.props;
        const { pricing, pricingType } = item;
        const { quantity } = this.state;

        let relevantPricing = [];
        let tierPrice = 0;
        let tierIndex = 0;

        const genericPricing = pricing
            .filter((obj) => !obj.customerID)
            .sort((a, b) => a.quantity - b.quantity);

        if (currentUser && !currentUser.anonymous) {
            const { customerID } = currentUser;
            const customerSpecificPricing = pricing
                .filter((obj) => obj.customerID === customerID)
                .sort((a, b) => a.quantity - b.quantity);

            if (!_.isEmpty(customerSpecificPricing)) {
                relevantPricing = customerSpecificPricing;
            } else {
                relevantPricing = genericPricing.filter((priceObj) =>
                    pricingType ? priceObj.type === pricingType : true
                );
            }
        } else {
            relevantPricing = genericPricing.filter((priceObj) =>
                pricingType ? priceObj.type === pricingType : true
            );
        }

        relevantPricing.forEach((tier, index) => {
            if (tier.quantity <= quantity) {
                tierPrice = tier.price;
                tierIndex = index;
            }
        });

        this.setState({
            relevantPricing,
            genericPricing,
            tierIndex,
            tierPrice,
        });
    };

    renderRelated = () => {
        const { related, relatedSet, relatedIndex, maxRelated } = this.state;

        const relatedObjects = related.map((object) => {
            const { imageURL, name, link, item } = object;

            return this.renderRelatedObject(imageURL, name, link, item);
        });

        if (!_.isEmpty(related)) {
            return (
                <Fragment>
                    <div
                        className="item-page-section-break"
                        style={{ marginTop: '2rem' }}
                    />
                    <div
                        className="item-page-related-items-container"
                        onMouseEnter={() => this.setState({ pause: true })}
                        onMouseLeave={() => this.setState({ pause: false })}
                    >
                        <div
                            className="no-button item-page-info-button"
                            style={{ color: '#002677', textAlign: 'center' }}
                        >
                            <span className="item-page-info-button-text">
                                <span style={{ marginRight: '0.5em' }}>
                                    <i className="fas fa-link" />
                                </span>
                                <span>Related Items</span>
                            </span>
                        </div>
                        <div className="item-page-related-items">
                            <button
                                className="item-page-arrow item-page-arrow-left"
                                disabled={!relatedIndex}
                                onClick={() =>
                                    this.setState({
                                        relatedSet: relatedSet - 1,
                                        relatedIndex: relatedIndex - maxRelated,
                                    })
                                }
                            >
                                <i className="far fa-chevron-left" />
                            </button>
                            {relatedObjects.slice(
                                relatedIndex,
                                relatedIndex + maxRelated
                            )}
                            <button
                                className="item-page-arrow item-page-arrow-right"
                                disabled={
                                    related.length <=
                                    maxRelated * (relatedSet + 1)
                                }
                                onClick={() =>
                                    this.setState({
                                        relatedSet: relatedSet + 1,
                                        relatedIndex: relatedIndex + maxRelated,
                                    })
                                }
                            >
                                <i className="far fa-chevron-right" />
                            </button>
                        </div>
                    </div>
                </Fragment>
            );
        }

        return '';
    };

    renderRelatedObject = (imageURL, name, link, item) => {
        const { classes } = this.props;

        return (
            <Link
                to={link}
                key={
                    name
                } /* onClick={() => addRelatedImpression(primarySku, item, name)}*/
            >
                <div
                    className="item-page-related-item"
                    style={{
                        backgroundImage: `url(${ITEM_IMG_URL}${imageURL})`,
                        backgroundSize: 'cover',
                    }}
                >
                    <div className="item-page-related-item-background">
                        <div className="item-page-related-item-name">
                            {name}
                        </div>
                    </div>
                    {item ? (
                        <Tooltip
                            title="Add to Cart"
                            placement="right"
                            className={`${classes.fab} item-page-related-item-button`}
                        >
                            <Fab
                                variant="extended"
                                color="secondary"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    this.addToCart(item);
                                }}
                            >
                                <i className="fas fa-cart-plus" />
                            </Fab>
                        </Tooltip>
                    ) : (
                        ''
                    )}
                </div>
            </Link>
        );
    };

    renderRelatedDots = () => {
        const { groups, showGroup } = this.state;
        const dots = [];

        if (groups > 1) {
            for (let i = 0; i < groups; i++) {
                dots.push(
                    <button
                        type="button"
                        key={`dot-${i}`}
                        className="no-button item-page-related-dot"
                        onClick={() => this.setState({ showGroup: i })}
                        style={
                            i === showGroup ? { opacity: 1 } : { opacity: 0.5 }
                        }
                    >
                        <i className="fas fa-circle" />
                        <div className="item-page-related-dot-number">
                            {i + 1}
                        </div>
                    </button>
                );
            }

            return dots;
        }

        return '';
    };

    renderPrice = () => {
        const { item, currentUser, dispatch } = this.props;
        const { sku, discontinued, msrp, replacementItemSku } = item;
        const { favorites } = { favorites: currentUser.favorites || [] };
        const { relevantPricing } = this.state;

        const favoritesContent =
            !currentUser.anonymous &&
            favorites &&
            (favorites.includes(sku) ? (
                <Button
                    size="small"
                    variant="outlined"
                    color="primary"
                    style={{ marginTop: -4, marginLeft: '1rem' }}
                    startIcon={
                        <i
                            className="fas fa-heart"
                            style={{ color: '#ba2d0b' }}
                        ></i>
                    }
                    onClick={() =>
                        dispatch(updateCustomerFavorites(sku, 'delete'))
                    }
                >
                    Saved to Favorites
                </Button>
            ) : (
                <Button
                    size="small"
                    variant="outlined"
                    style={{ marginTop: -4, marginLeft: '1rem' }}
                    startIcon={<i className="far fa-heart"></i>}
                    onClick={() =>
                        dispatch(updateCustomerFavorites(sku, 'add'))
                    }
                >
                    Add to Favorites
                </Button>
            ));
        //     <Tooltip title="Remove from Favorites">
        //         <IconButton
        //             size="large"
        //             style={{ position: 'relative' }}
        //             onClick={() =>
        //                 dispatch(updateCustomerFavorites(sku, 'delete'))
        //             }
        //         >
        //             <i
        //                 className="fas fa-heart"
        //                 style={{ color: '#73ba9b' }}
        //             ></i>
        //             <span
        //                 style={{
        //                     display: 'inline-block',
        //                     position: 'absolute',
        //                     marginLeft: '1.5rem',
        //                 }}
        //             >
        //                 Favorited
        //             </span>
        //         </IconButton>
        //     </Tooltip>
        // ) : (
        //     <Tooltip title="Add to Favorites">
        //         <IconButton
        //             size="large"
        //             style={{ position: 'relative' }}
        //             onClick={() =>
        //                 dispatch(updateCustomerFavorites(sku, 'add'))
        //             }
        //         >
        //             <i className="far fa-heart"></i>
        //             <span
        //                 style={{
        //                     display: 'inline-block',
        //                     position: 'absolute',
        //                     right: '-6.5rem',
        //                     whiteSpace: 'nowrap',
        //                     fontSize: '1rem',
        //                     fontFamily: 'IBM Plex Sans Condensed',
        //                 }}
        //             >
        //                 Add to Favorites
        //             </span>
        //         </IconButton>
        //     </Tooltip>
        // ));

        if (!_.isEmpty(relevantPricing)) {
            const displayMsrp =
                typeof msrp === 'number' && msrp > relevantPricing[0].price;

            return relevantPricing.length > 1 ? (
                <div>
                    {!discontinued && displayMsrp && (
                        <span className="condensed msrp">
                            MSRP {formatCurrency(msrp)}
                        </span>
                    )}
                    {!discontinued && (
                        <>
                            <Tooltip
                                title="The pricing of this item is dependent on quantity ordered. Higher quantities yield lower costs per unit."
                                placement="bottom-start"
                            >
                                <i className="fas fa-question-circle item-page-multiple-price-question" />
                            </Tooltip>
                            <span className="bold">
                                {` ${formatCurrency(
                                    relevantPricing[relevantPricing.length - 1]
                                        .price
                                )} `}
                            </span>
                            <span>{'\u2005'}and up </span>
                            <div className="item-page-sku condensed">{sku}</div>
                        </>
                    )}
                    {discontinued && !replacementItemSku && (
                        <div className="item-page-discontinued condensed">
                            Call to Order
                        </div>
                    )}
                    {discontinued && replacementItemSku && (
                        <>
                            <div className="item-page-discontinued condensed">
                                Discontinued
                            </div>
                            <div style={{ margin: '0 0.5rem' }}>·</div>
                            <div className="item-page-discontinued condensed">
                                Replaced by{' '}
                                <Link to={`/item/${replacementItemSku}`}>
                                    {replacementItemSku}
                                </Link>
                            </div>
                        </>
                    )}
                    {favoritesContent}
                </div>
            ) : (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {!discontinued && displayMsrp && (
                        <span className="condensed msrp">
                            MSRP {formatCurrency(msrp)}
                        </span>
                    )}
                    {!discontinued && (
                        <>
                            <span
                                className="bold"
                                style={
                                    displayMsrp
                                        ? {
                                              fontSize: '1.5rem',
                                              color: '#dba124',
                                          }
                                        : {}
                                }
                            >
                                {`${formatCurrency(relevantPricing[0].price)}`}
                            </span>
                            <div className="item-page-sku condensed">{sku}</div>
                        </>
                    )}
                    {discontinued && !replacementItemSku && (
                        <div className="item-page-discontinued condensed">
                            Call to Order
                        </div>
                    )}
                    {discontinued && replacementItemSku && (
                        <>
                            <div className="item-page-discontinued condensed">
                                Discontinued
                            </div>
                            <div style={{ margin: '0 0.5rem' }}>·</div>
                            <div className="item-page-discontinued condensed">
                                Replaced by{' '}
                                <Link to={`/item/${replacementItemSku}`}>
                                    {replacementItemSku}
                                </Link>
                            </div>
                        </>
                    )}
                    {favoritesContent}
                </div>
            );
        }

        return '—';
    };

    renderPricingChart = () => {
        const { item, inCart } = this.props;
        const { unit, amazonLink, discontinued } = item;
        const { quantity, relevantPricing, tierIndex } = this.state;

        const display = (() => {
            if (inCart) {
                return 'Already in Cart';
            }

            return 'Add to Cart';
        })();

        // const favoritesContent =
        //     !currentUser.anonymous &&
        //     favorites &&
        //     (favorites.includes(sku) ? (
        //         <Button
        //             variant="contained"
        //             style={{
        //                 backgroundColor: '#ba2d0b',
        //                 color: 'white',
        //                 display: 'inline-block',
        //                 width: '35%',
        //                 marginRight: '1em',
        //                 padding: '0.75em 0',
        //             }}
        //             onClick={() =>
        //                 dispatch(updateCustomerFavorites(sku, 'delete'))
        //             }
        //         >
        //             <i
        //                 className="fas fa-heart-broken"
        //                 style={{ marginRight: '0.5em' }}
        //             />
        //             <span>Unfavorite</span>
        //         </Button>
        //     ) : (
        //         <Button
        //             variant="contained"
        //             style={{
        //                 backgroundColor: '#73ba9b',
        //                 color: 'white',
        //                 display: 'inline-block',
        //                 width: '35%',
        //                 marginRight: '1em',
        //                 padding: '0.75em 0',
        //             }}
        //             onClick={() =>
        //                 dispatch(updateCustomerFavorites(sku, 'add'))
        //             }
        //         >
        //             <i
        //                 className="fas fa-heart"
        //                 style={{ marginRight: '0.5em' }}
        //             />
        //             <span>Favorite</span>
        //         </Button>
        //     ));

        const addToCart = !discontinued && (
            <div className="item-page-add-to-cart">
                {/* <TextField
                    type="number"
                    label={pluralize(/^ea/i.test(unit) ? 'Unit' : unit, 2)}
                    variant="filled"
                    min={1}
                    max={99}
                    color="primary"
                    value={quantity}
                    disabled={discontinued}
                    onChange={(e) =>
                        this.handleUpdateQuantity(parseInt(e.target.value, 10))
                    }
                    style={{ marginRight: '1em' }}
                /> */}
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginRight: '1rem',
                    }}
                >
                    <Fab
                        size="small"
                        color="primary"
                        onClick={() =>
                            this.handleUpdateQuantity(
                                quantity === 1 ? 1 : quantity - 1
                            )
                        }
                    >
                        <i className="fas fa-minus"></i>
                    </Fab>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            height: 40,
                        }}
                    >
                        <input
                            type="number"
                            min={1}
                            step={1}
                            value={quantity}
                            ref={(ref) => {
                                this.cartQuantity = ref;
                            }}
                            disabled={discontinued}
                            className="item-data-qty-input condensed"
                            onChange={(e) => {
                                const { value } = e.target;

                                if (!value) this.handleUpdateQuantity('');

                                const numberValue = parseInt(value, 10);
                                if (numberValue > 0) {
                                    this.handleUpdateQuantity(
                                        parseInt(e.target.value, 10)
                                    );
                                }
                            }}
                        />
                        <div style={{ height: 0 }}>
                            {unit !== 'Each' && pluralize(unit, quantity)}
                        </div>
                    </div>
                    <Fab
                        size="small"
                        color="primary"
                        onClick={() =>
                            this.handleUpdateQuantity(
                                quantity === 99 ? 99 : quantity + 1
                            )
                        }
                    >
                        <i className="fas fa-plus"></i>
                    </Fab>
                </div>
                <Button
                    variant="contained"
                    color="primary"
                    style={{
                        display: 'inline-block',
                        padding: '0.75em 0',
                        marginRight: '0.5em',
                        width: '100%',
                        minWidth: 275,
                    }}
                    disabled={
                        inCart ||
                        discontinued ||
                        !quantity ||
                        typeof quantity !== 'number'
                    }
                    onClick={() => this.addToCart()}
                >
                    <i
                        className="fas fa-shopping-cart"
                        style={{ marginRight: '0.5em' }}
                    />
                    <span>{display}</span>
                </Button>
                {amazonLink && (
                    <Button
                        variant="contained"
                        style={{
                            backgroundColor: 'black',
                            color: 'white',
                            display: 'inline-block',
                            width: '100%',
                            marginRight: '1em',
                            padding: '0.75em 0.5rem',
                            whiteSpace: 'nowrap',
                        }}
                        disabled={!amazonLink}
                        onClick={() =>
                            window.open(`${AMAZON_BASE_URL}${amazonLink}`)
                        }
                    >
                        <span>Buy on </span>
                        <img
                            src={amazonLogo}
                            alt=""
                            style={{
                                height: 20,
                                width: 'auto',
                                position: 'relative',
                                top: 9,
                                left: 1,
                            }}
                        />
                    </Button>
                )}
            </div>
        );

        return (
            <Fragment>
                <section
                    className="item-page-pricing-section"
                    style={{ maxWidth: 700 }}
                >
                    {addToCart}
                    {relevantPricing.length > 1 && (
                        <Fragment>
                            <Divider style={{ marginBottom: '2.5rem' }} />
                            <div className="item-page-pricing-chart">
                                {relevantPricing.map((prc, index) => {
                                    const {
                                        quantity: currentQuantity,
                                        price: currentPrice,
                                    } = prc;

                                    return (
                                        <button
                                            type="button"
                                            className="no-button"
                                            style={{
                                                width: '100%',
                                                margin: '0 2px',
                                            }}
                                            onClick={() =>
                                                this.setState({
                                                    quantity: currentQuantity,
                                                })
                                            }
                                            key={`quantity-${currentQuantity}`}
                                        >
                                            <div
                                                className="item-page-pricing-box"
                                                style={
                                                    tierIndex === index
                                                        ? {
                                                              backgroundColor:
                                                                  '#e6e8f3',
                                                              color: '#002677',
                                                              boxShadow:
                                                                  '0 0 0 1px #002677',
                                                          }
                                                        : {
                                                              boxShadow:
                                                                  '0 0 0 0 white',
                                                          }
                                                }
                                            >
                                                {!!index && (
                                                    <div className="item-page-pricing-box-save">
                                                        <span
                                                            className="bold"
                                                            style={{
                                                                color: '#73ba93',
                                                            }}
                                                        >{`${Math.round(
                                                            100 *
                                                                (1 -
                                                                    currentPrice /
                                                                        relevantPricing[0]
                                                                            .price)
                                                        )}%`}</span>
                                                        <span> off</span>
                                                    </div>
                                                )}
                                                <div className="item-page-pricing-box-price">{`${formatCurrency(
                                                    currentPrice
                                                )} ea.`}</div>
                                                <div className="item-page-pricing-box-unit">{`${currentQuantity}+ ${pluralize(
                                                    (/^ea/i.test(unit)
                                                        ? 'unit'
                                                        : unit
                                                    ).toLowerCase(),
                                                    currentQuantity
                                                )}`}</div>
                                            </div>
                                        </button>
                                    );
                                })}
                            </div>
                        </Fragment>
                    )}
                    <img
                        src={priceMatch}
                        className="configurator-form-badge"
                        style={
                            discontinued
                                ? { display: 'none' }
                                : {
                                      position: 'absolute',
                                      top: -50,
                                      right: '-175px',
                                  }
                        }
                        alt="Kenco will price-match on any configured product."
                    />
                </section>
            </Fragment>
        );
    };

    renderDescription = () => {
        const { item } = this.props;
        const { description } = item;

        return <Markdown>{description}</Markdown>;
    };

    renderVariant = () => {
        const { variations, item } = this.props;
        const { variation } = this.state;

        const { variationId, items: itemsData } = variations || {};
        const { attribute, type } = variation || {};

        const { variations: originalVariations } = item;
        const originalVariation = (originalVariations || []).find(
            (v) => v.id === variationId
        );

        if (itemsData && originalVariation) {
            const items = itemsData.reduce((array, item) => {
                const { sku, variations: itemVariations } = item;

                const relevantVariation = itemVariations.find(
                    (itemVariation) => itemVariation.id === variationId
                );

                if (relevantVariation) {
                    const { tile } = relevantVariation;

                    array.push(
                        <Link
                            key={sku}
                            to={`/item/${sku}`}
                            onMouseEnter={() =>
                                this.setState({
                                    overrideImage: true,
                                    variation: relevantVariation,
                                })
                            }
                            onMouseLeave={() =>
                                this.setState({
                                    overrideImage: false,
                                    variation: originalVariation,
                                })
                            }
                        >
                            <img
                                src={`${ITEM_IMG_URL}${tile}`}
                                alt={`${item ? item.name : 'item'} - ${
                                    variation ? variation.name : 'variation'
                                }`}
                                className="item-page-variants-tile"
                            />
                        </Link>
                    );
                }

                return array;
            }, []);

            return (
                <div style={{ width: '100%', maxWidth: 450 }}>
                    <div className="item-page-variants">
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div className="item-page-section-break"></div>
                            <div
                                className="blue bold"
                                style={{
                                    whiteSpace: 'nowrap',
                                    margin: '0 1rem',
                                }}
                            >
                                Other Options
                            </div>
                            <div className="item-page-section-break"></div>
                        </div>
                        <div className="item-page-variants-title">
                            {type}: <span className="bold">{attribute}</span>
                        </div>
                        <div className="item-page-variants-container">
                            {items}
                        </div>
                    </div>
                </div>
            );
        }

        return '';
    };

    renderInfo = () => {
        const { item } = this.props;
        const { sku, downloads, videoURL, availability, weight, pkgDetails } =
            item;
        const { show } = this.state;

        if (show === 'video') {
            return (
                <div className="item-page-video-container">
                    <iframe
                        title={`video-${sku}`}
                        width="560"
                        height="315"
                        src={`https://www.youtube.com/embed/${videoURL}?rel=0`}
                        frameBorder="0"
                        allow="autoplay; encrypted-media"
                        allowFullScreen
                    />
                </div>
            );
        }
        if (show === 'downloads') {
            return (
                <ul className="item-page-downloads">
                    {downloads.map((data) => (
                        <li
                            key={`download-${data.file}`}
                            className="item-page-download"
                        >
                            <a
                                href={`${DOWNLOADS_URL}${data.file}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                download
                            >
                                <span className="download-item">
                                    {data.description}
                                </span>
                            </a>
                        </li>
                    ))}
                </ul>
            );
        }
        if (show === 'shipping') {
            return (
                <Fragment>
                    <p className="shipping-list-item list-item">{`${pkgDetails}.`}</p>
                    <p className="shipping-list-item list-item">{`${availability}.`}</p>
                    <p className="shipping-list-item list-item">{`Weighs ${weight} ${pluralize(
                        'lb',
                        weight
                    )}.`}</p>
                </Fragment>
            );
        }

        return '';
    };

    renderCategories = () => {
        const { brands, item } = this.props;
        const { mfgrName, path } = item;

        const relevantBrands =
            brands && brands.length
                ? brands.filter((b) => {
                      const { id, categories } = b;

                      if (id === mfgrName) {
                          return false;
                      }

                      if (categories) {
                          const categoryRegExp = new RegExp(
                              `^(${categories.join('|')}).*`,
                              'gi'
                          );

                          return path.reduce(
                              (boolean, string) =>
                                  boolean || categoryRegExp.test(string),
                              false
                          );
                      }

                      return false;
                  })
                : [];

        const itemBrand = brands.find((brand) => brand.id === mfgrName);

        if (itemBrand) {
            relevantBrands.unshift(itemBrand);
        }

        const categories = [
            ...relevantBrands.map((brand) => ({
                value: brand.name,
                to: `/brands/${brand.id.toLowerCase()}`,
            })),
        ];

        return (
            <>
                {!!categories.length && (
                    <span
                        style={{
                            fontWeight: 400,
                            fontFamily: 'IBM Plex Sans Condensed',
                            marginRight: '-1rem',
                        }}
                    >
                        See also
                    </span>
                )}
                {categories.map((category) => (
                    <li key={category.value}>
                        <Link to={category.to}>{category.value}</Link>
                    </li>
                ))}
            </>
        );
    };

    renderReviews = (full) => {
        const { expandReviews } = this.state;

        const contents = [
            {
                name: 'Namey McName',
                date: 'Nov 2022',
                score: 5,
                text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Eu tincidunt tortor aliquam nulla facilisi cras fermentum. Ac turpis egestas sed tempus urna et pharetra pharetra massa. Gravida quis blandit turpis cursus in.',
            },
            {
                name: 'Namey McName',
                date: 'Nov 2022',
                score: 5,
                text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Eu tincidunt tortor aliquam nulla facilisi cras fermentum. Ac turpis egestas sed tempus urna et pharetra pharetra massa. Gravida quis blandit turpis cursus in.',
            },
            {
                name: 'Namey McName',
                date: 'Nov 2022',
                score: 5,
                text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Eu tincidunt tortor aliquam nulla facilisi cras fermentum. Ac turpis egestas sed tempus urna et pharetra pharetra massa. Gravida quis blandit turpis cursus in.',
            },
            {
                name: 'Namey McName',
                date: 'Nov 2022',
                score: 3,
                text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Eu tincidunt tortor aliquam nulla facilisi cras fermentum. Ac turpis egestas sed tempus urna et pharetra pharetra massa. Gravida quis blandit turpis cursus in.',
            },
        ];

        const main = (
            <div
                style={{
                    display: 'flex',
                    gap: '0.5rem',
                    alignContent: 'center',
                    marginLeft: '-0.25rem',
                }}
            >
                <Rating value={4.3} readOnly precision={0.5} />
                <div
                    style={{
                        marginTop: 2,
                        fontFamily: 'IBM Plex Sans Condensed',
                    }}
                >
                    4.3 / 5 (0 reviews)
                </div>
            </div>
        );

        if (full) {
            return (
                <div className="item-page-row">
                    <h2 className="item-page-row-header">Customer Reviews</h2>
                    <div className="item-page-expand">
                        {main}
                        <IconButton
                            aria-label="expand-reviews"
                            onClick={() =>
                                this.setState({
                                    expandReviews: !expandReviews,
                                })
                            }
                            style={{ marginTop: -20 }}
                        >
                            <i
                                className={
                                    expandReviews
                                        ? 'fas fa-chevron-down'
                                        : 'fas fa-chevron-up'
                                }
                            ></i>
                        </IconButton>
                    </div>
                    <Collapse in={expandReviews}>
                        <div className="item-page-row-content-list">
                            {contents.map((content) => (
                                <div
                                    key={content.question}
                                    style={{ display: 'flex' }}
                                >
                                    <div className="item-page-row-content">
                                        <div className="item-page-row-content-header">
                                            {content.name}
                                        </div>
                                        <p className="item-page-row-content-text">
                                            {content.text}
                                        </p>
                                        <div
                                            style={{
                                                display: 'flex',
                                                gap: '1rem',
                                                fontFamily:
                                                    'IBM Plex Sans Condensed',
                                                margin: '0.25rem -0.25rem 0',
                                            }}
                                        >
                                            <Rating
                                                value={content.score}
                                                readOnly
                                            />
                                            <div
                                                style={{
                                                    fontStyle: 'italic',
                                                    marginTop: 2,
                                                }}
                                            >
                                                {content.date}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Collapse>
                </div>
            );
        }

        return (
            <div style={{ marginTop: '-0.75rem', marginBottom: '0.75rem' }}>
                {main}
            </div>
        );
    };

    renderQuestions = () => {
        const { expandQuestions } = this.state;

        const contents = [
            {
                question:
                    'Question question question question question question?',
                answer: 'Answer answer answer answer answer.',
            },
            {
                question:
                    'Question question question question question question?',
                answer: 'Answer answer answer answer answer.',
            },
            {
                question:
                    'Question question question question question question?',
                answer: 'Answer answer answer answer answer.',
            },
            {
                question:
                    'Question question question question question question?',
                answer: 'Answer answer answer answer answer.',
            },
        ];

        return (
            <div className="item-page-row">
                <h2 className="item-page-row-header">
                    Questions &amp; Answers
                </h2>
                <div className="item-page-expand">
                    <div>{contents.length} Question(s)</div>
                    <IconButton
                        aria-label="expand-questions"
                        onClick={() =>
                            this.setState({ expandQuestions: !expandQuestions })
                        }
                        style={{ marginTop: -20 }}
                    >
                        <i
                            className={
                                expandQuestions
                                    ? 'fas fa-chevron-down'
                                    : 'fas fa-chevron-up'
                            }
                        ></i>
                    </IconButton>
                </div>
                <Collapse in={expandQuestions}>
                    <div className="item-page-row-content-list">
                        {contents.map((content, index) => (
                            <div
                                key={content.question}
                                style={{ display: 'flex' }}
                            >
                                <div style={{ fontWeight: 'bold' }}>
                                    {index + 1}.{'\u2002'}
                                </div>
                                <div className="item-page-row-content">
                                    <div className="item-page-row-content-header">
                                        {content.question}
                                    </div>
                                    <p className="item-page-row-content-text">
                                        {content.answer}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </Collapse>
            </div>
        );
    };

    render() {
        const { item, breadcrumbs, history } = this.props;
        const {
            images,
            name,
            sellingPoints,
            sku,
            path,
            folder360view,
            weight,
            availability,
            pkgDetails,
            downloads,
            videoURL,
            dimensions,
            promotionCoupon,
            mpn,
        } = item;

        const { image, overrideImage, variation, showScrub, showVideo } =
            this.state;

        const relevantImages = images.filter((image) => !image.thumbnail);
        const { imageFile } = relevantImages[image];
        const isPriceGunLabel = !!path.find((pth) => pth.startsWith('110.020'));

        const { width, height, length } = dimensions || {
            width: 1,
            height: 1,
            length: 0,
        };

        return (
            <div className="item-page-container">
                {promotionCoupon &&
                    promotionCoupon.promotion &&
                    promotionCoupon.promotion.header && (
                        <div className="item-page-promotion">
                            <div className="item-page-promotion-text">
                                <span className="bold">Promotion!</span>
                                <span
                                    style={{
                                        display: 'inline-block',
                                        margin: '0 5px',
                                    }}
                                >
                                    {promotionCoupon.promotion.header}
                                </span>
                                See below for details.
                            </div>
                        </div>
                    )}
                <div className="item-page-row-one">
                    <div className="item-page-container-two">
                        {breadcrumbs}
                        <h1
                            className="products-header"
                            style={{ marginTop: '-0.25em' }}
                        >
                            {name}
                        </h1>
                        <ul className="item-page-categories">
                            {this.renderCategories()}
                        </ul>
                        <div className="item-page-price">
                            {this.renderPrice()}
                        </div>
                        {/* {this.renderReviews()} */}
                        <ul className="item-page-selling-points">
                            {sellingPoints.map((slp) => (
                                <li
                                    key={slp}
                                    className="item-page-selling-point"
                                >
                                    {slp}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div style={{ maxWidth: 450, position: 'relative' }}>
                        {isPriceGunLabel && (
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={() =>
                                    history.push(`/build/price-gun?sku=${sku}`)
                                }
                                style={{
                                    position: 'absolute',
                                    top: 10,
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                }}
                            >
                                <span>Customize</span>
                            </Button>
                        )}
                        <div className="item-page-image-box">
                            <div className="item-page-image-container">
                                {overrideImage && (
                                    <img
                                        src={`${ITEM_IMG_URL}${variation.gallery}`}
                                        alt={`${name} - ${
                                            variation
                                                ? variation.name
                                                : 'variation'
                                        }`}
                                        className="item-page-image"
                                    />
                                )}
                                {!showScrub && !showVideo && !overrideImage && (
                                    <img
                                        src={`${ITEM_IMG_URL}${imageFile}`}
                                        alt={`${name} product image`}
                                        className="item-page-image"
                                    />
                                )}
                                {showScrub && !showVideo && !overrideImage && (
                                    <ImageScrub url={folder360view} />
                                )}
                                {showVideo && !showScrub && !overrideImage && (
                                    <iframe
                                        title={`video-${sku}`}
                                        width="400"
                                        height="320"
                                        src={`https://www.youtube.com/embed/${videoURL}?rel=0`}
                                        frameBorder="0"
                                        allow="autoplay; encrypted-media"
                                        style={{ margin: '3rem 0 -3rem' }}
                                        allowFullScreen
                                    />
                                )}
                            </div>
                            <div className="item-page-image-alternates">
                                {relevantImages.length > 1 &&
                                    relevantImages.map((img, index) => {
                                        const { imageFile: file } = img;

                                        return (
                                            <div
                                                className="item-page-image-alternate-container"
                                                key={file}
                                            >
                                                <button
                                                    type="button"
                                                    className="no-button"
                                                    onClick={() =>
                                                        this.setState({
                                                            image: index,
                                                            showScrub: false,
                                                            showVideo: false,
                                                        })
                                                    }
                                                >
                                                    <img
                                                        src={`${ITEM_IMG_URL}${file}`}
                                                        alt={`${name} alternate view`}
                                                        className="item-page-alternate-image"
                                                    />
                                                </button>
                                            </div>
                                        );
                                    })}
                                {folder360view && (
                                    <div className="item-page-image-alternate-container">
                                        <button
                                            type="button"
                                            className="no-button"
                                            onClick={() =>
                                                this.setState({
                                                    showScrub: true,
                                                    showVideo: false,
                                                })
                                            }
                                        >
                                            <img
                                                src={deg360}
                                                alt=""
                                                className="item-page-alternate-image"
                                            />
                                        </button>
                                    </div>
                                )}
                                {videoURL && (
                                    <div className="item-page-image-alternate-container">
                                        <button
                                            type="button"
                                            className="no-button"
                                            onClick={() =>
                                                this.setState({
                                                    showVideo: true,
                                                })
                                            }
                                        >
                                            <i
                                                className="far fa-play-circle item-page-alternate-image blue orange"
                                                style={{ fontSize: 50 }}
                                            ></i>
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="item-page-row-one"
                    style={{
                        justifyContent: 'space-between',
                        alignItems: 'flex-center',
                        marginTop: '2rem',
                    }}
                >
                    {this.renderPricingChart()}
                    {this.renderVariant()}
                </div>
                {this.renderRelated()}
                {promotionCoupon &&
                    promotionCoupon.promotion &&
                    promotionCoupon.promotion.details && (
                        <>
                            <div className="item-page-section-break"></div>
                            <div className="item-page-row">
                                <h2 className="item-page-row-header">
                                    Promotion Details
                                </h2>
                                <p>
                                    <Markdown>
                                        {promotionCoupon.promotion.details}
                                    </Markdown>
                                </p>
                            </div>
                        </>
                    )}
                <div className="item-page-section-break"></div>
                <div className="item-page-row">
                    <h2 className="item-page-row-header">Description</h2>
                    <p>{this.renderDescription()}</p>
                </div>
                <div className="item-page-section-break"></div>
                <div className="item-page-row">
                    <h2 className="item-page-row-header">Specifications</h2>
                    {mpn && <p>MPN: {mpn} </p>}
                    <p>{availability}</p>
                    <p>{pkgDetails}</p>
                    {!!(width || height || length) && (
                        <p>
                            {`Dimensions: `}
                            {!!width && `${width}" W`}
                            {!!height && `${!!width && ' × '}${height}" H`}
                            {!!length &&
                                `${(!!width || height) && ' × '}${length}" L`}
                        </p>
                    )}
                    <p>Weight: {weight} lbs</p>
                </div>
                {downloads && !!downloads.length && (
                    <>
                        <div className="item-page-section-break"></div>
                        <div className="item-page-row">
                            <h2 className="item-page-row-header">Downloads</h2>
                            <ul className="item-page-downloads">
                                {downloads.map((data) => (
                                    <li
                                        key={`download-${data.file}`}
                                        className="item-page-download"
                                    >
                                        <a
                                            href={`${DOWNLOADS_URL}${data.file}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            download
                                        >
                                            <span className="download-item">
                                                {data.description}
                                            </span>
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </>
                )}
                {/* <div className="item-page-section-break"></div>
                {this.renderQuestions()}
                <div className="item-page-section-break"></div>
                {this.renderReviews(true)} */}
            </div>
        );
    }
}

export default withStyles(styles)(ItemPage);
